import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { MainMenuItem } from 'pages/app/components/mainMenu/components/MainMenuItem';
import { SideBarMenuItem } from 'pages/app/components/SideBarMenu/components/SideBarMenuItem';
import Messages from 'constants/rpcTypes';
import { ACTIVE_CODAT_STATUS } from 'pages/accountingStatementRequests/constant';
import { useEventListener } from 'hooks';
import { getAccountingRequests } from 'api/accouning';
import { AccountingRequestItem } from 'pages/accountingStatementRequests/types';
import { setAccountingRequests } from 'actions/accountingRequests';
import { Badge } from 'components/ui/badge';

type Props = {
  icon: string;
  title: string;
  selected?: boolean;
  withTooltip?: boolean;
};

const getActiveAccounitngRequestsCount = (requests: AccountingRequestItem[]) =>
  requests.filter((request) => request.codatStatus === ACTIVE_CODAT_STATUS)
    .length;

export const AccountingRequestMainMenuItem: FC<Props> = ({
  icon,
  title,
  selected,
  withTooltip,
}) => {
  const [requestsCount, setRequestsCount] = useState(0);
  const dispatch = useDispatch();
  const menuVersion = useSelector(
    (state: RootState) => state.layoutConfiguration.menuVersion
  );
  const isOldMenu = menuVersion === 'old';

  useEffect(() => {
    getAccountingRequests();
  }, []);

  useEventListener(
    {
      events: [Messages.AccountingDataRequest_List],
      onEvent: (
        _,
        data: {
          payload: { [key: string]: AccountingRequestItem };
        }
      ) => {
        if (!data?.payload) {
          return;
        }

        let accountingRequests;

        if (Array.isArray(data.payload)) {
          accountingRequests = data.payload;
        } else {
          const accountingRequestsObject = data.payload;
          accountingRequests = Object.values(accountingRequestsObject);
        }

        dispatch(setAccountingRequests(accountingRequests));
        setRequestsCount(getActiveAccounitngRequestsCount(accountingRequests));
      },
    },
    []
  );

  return (
    <>
      {isOldMenu ? (
        <MainMenuItem icon={icon} title={title} />
      ) : (
        <SideBarMenuItem
          icon={icon}
          title={title}
          selected={selected}
          withTooltip={withTooltip}
        />
      )}
      {requestsCount > 0 && (
        <Badge
          position={{
            right: 0,
            top: -2,
          }}
          count={requestsCount}
        />
      )}
    </>
  );
};
